export default __webpack_public_path__ + "static/media/CommanderPool.b8e4afcd.png";